import { BaseRequest } from './BaseRequest';

export class MetricsRequest extends BaseRequest {
    Filter : string | null;
    
    constructor(filter: string, clusterName: string, botIdentifier: string) {
      super();
      this.Filter = filter;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
    }
}